import { View } from './view'

export const LoginAsV2 = View
